const FALLBACK_MAPBOX_TOKEN =
  "pk.eyJ1Ijoic3FpaSIsImEiOiJja3kzYXlnNHkwMGNpMnNwN2RtMGhxMjI4In0.RpbUFrXuGm4d_QjFNIYo9A";

export const MAPBOX_TOKEN =
  process.env.REACT_APP_MAPBOX_TOKEN?.trim() || FALLBACK_MAPBOX_TOKEN;
